var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-file-input',{attrs:{"dense":"","multiple":"","chips":"","outlined":"","type":"file","prepend-inner-icon":"mdi-file-upload","prepend-icon":""},on:{"change":_vm.onSelect}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }